<template lang="pug">
  v-container.py-16.text-center
    h1.text-h5.mb-4 找不到這個頁面
    p 網址可能已變更，請從首頁重新選擇需要的服務。
    v-btn(color="primary" :to="{ name: 'Index' }") 回到首頁
</template>

<script>
export default { name: "NotFound" };
</script>
